<template>
<div class="staff">
    <van-sticky>
        <van-nav-bar title="工会服务" left-arrow @click-left="onClickLeft" />
    </van-sticky>
    <div class="staffHeader">
        <img src="@/assets/images/staff_02.jpg" alt="" width="100%" height="auto">
    </div>
    <grid class="gridinfo">
        <grid-item text="解困申请流程" to="/puhui/services/staff/difficulty">
            <img slot="icon" src="@/assets/images/4-01.png">
        </grid-item>
        <grid-item text="互助保障申请指南" to="/puhui/services/staff/help">
            <img slot="icon" src="@/assets/images/h2-01.png">
        </grid-item>
        <grid-item text="球馆活动信息" to="/puhui/services/staff/gymnasium">
            <img slot="icon" src="@/assets/images/h4-01.png">
        </grid-item>
        <grid-item text="职工之家活动信息" to="/puhui/services/staff/home">
            <img slot="icon" src="@/assets/images/1-01.png">
        </grid-item>
        <grid-item text="婚恋服务信息" to="/puhui/services/staff/love">
            <img slot="icon" src="@/assets/images/h5-01.png">
        </grid-item>
        <grid-item text="培创中心简介" to="/puhui/services/staff/train">
            <img slot="icon" src="@/assets/images/h6-01.png">
        </grid-item>
        <grid-item text="扫黑除恶宣传窗口" to="/puhui/services/staff/sweepblack">
            <img slot="icon" src="@/assets/images/h7-01.png">
        </grid-item>
        <grid-item text="工会活动" to="">
            <img slot="icon" src="@/assets/images/h8-01.png">
        </grid-item>
    </grid>
    <van-divider>工会服务热线电话0775一12351</van-divider>
   
</div>
</template>

<script>
import Grid from '@/components/Grid'
import GridItem from '@/components/GridItem'

export default {
    name: 'staff',

    components: {
        Grid,
        GridItem
    },
    created() {
        let title = "工会服务";
        if (this.$getUA() === 1) {
            this.$callApp("Android", "onJSAppSetTitle", title); //调用安卓的设置标题方法
            this.$callApp("Android", "SetWebViewZoom", false)
        } else if (this.$getUA() === 2) {
        
            this.$callApp("iOS", "getWebViewTitleMethod", title); //调用IOS设置标题的方法
            this.$callApp("iOS", "EnableWebZoomMethod", false)
        }
    },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
  },
}
</script>

<style lang="less" scoped>
.staff {
    background-color: #fff;
}
.van-divider{
    font-size: 13px;
}
.staffHeader {
    padding-top: 5px;
}
.gridinfo{
  img {
      margin-left: 5px;
      width: 40px;
      height: 40px;
}
}

</style>
